<div class="quickbet-content qb-partial-overlay" [ngClass]="{ suspended: selection.disabled }" data-crlat="quickbet.content">
    <div class="quickbet-sectionwrap">
        <section class="qb-po-selection-close-btn">
            <div class="qb-po-sln-close-btn" data-crlat="selectionCloseButton" (click)="removeSelection()">
                <svg>
                    <use xlink:href="#close-icon"></use>
                </svg>
            </div>
        </section>
        @if (selection.outcomeId) {
            <section class="qb-content-info" [ngClass]="{ 'odd-boost-active': canBoostSelection }">
                <div class="selection-outcome-info">
                    <p class="outcome-name" [textContent]="selection?.outcomeName | callBack: filterPlayerName : this" data-crlat="selectionName"></p>
                    @if (selection.disabled) {
                        <p class="qb-suspended-sign">SUSP</p>
                    }
                </div>
                <p class="market-name" [textContent]="filterAddScore(selection)" data-uat="marketName"></p>
                <p class="event-name" [textContent]="selection.eventName" data-uat="eventName"></p>
            </section>
        }
        <section id="quickBetEW" class="qb-stake-section" data-crlat="section.stake">
            <div class="qb-odds-stake-wrapper">
                <div class="odds">
                    @if (selection.hasLP) {
                        <span
                            class="odds-value"
                            [ngClass]="{ crossed: canBoostSelection && selection.isBoostActive }"
                            [textContent]="selection.newOddsValue || selection.oldOddsValue"
                            data-crlat="odds"></span>
                    }
                    @if (selection.hasSP) {
                        <span class="odds-value" [i18n]="'quickbet.isSP'" data-crlat="odds"></span>
                    }
                    @if (selection.hasSPLP) {
                        <label class="odds-select-label" data-crlat="odds">
                            <lazy-component
                                moduleUri="@freebetsModule/freebets.module#FreebetsModule"
                                [inputs]="{
                                    options: selection.oddsSelector,
                                    selectedValue: selection.isLP ? 'LP' : 'SP',
                                    disabled: selection.disabled,
                                    mode: canBoostSelection && selection.isBoostActive ? 'secondary' : 'default',
                                }"
                                [outputs]="['valueChange']"
                                (event)="priceTypeChange($event)"
                                entryComponent="LpSpDropdownComponent">
                            </lazy-component>
                        </label>
                    }
                    @if (canBoostSelection && selection.isBoostActive) {
                        <!-- Boosted price -->
                        <lazy-component
                            moduleUri="@oddsBoostModule/odds-boost.module#OddsBoostModule"
                            entryComponent="OddsBoostPriceComponent"
                            [inputs]="{ oldPrice: boostOldPrice, newPrice: boostNewPrice }"
                            class="quickbet-boosted-price">
                        </lazy-component>
                    }
                </div>
                <div class="stake" data-crlat="stake.amountInputForm">
                    <label
                        [ngClass]="selectionAmountClasses"
                        class="input-stake-label"
                        [attr.data-currency]="selection.currency"
                        [textContent]="selection.stake ? selection.currency : ''">
                    </label>
                    <input
                        id="stake-input"
                        class="stake-input"
                        placeholder="Stake"
                        (click)="openFullOverlay($event)"
                        [disabled]="selection.disabled || serviceClosureService.userServiceClosureOrPlayBreak"
                        [(ngModel)]="selection.stake"
                        data-crlat="value" />
                </div>
            </div>
            <div class="each-way" *ngIf="selection.isEachWayAvailable" data-crlat="eachWayForm">
                <div class="each-way-highlight eachWay-tooltip">
                    <div *ngIf="disableEachWayTooltip" [tooltip]="'eachWay'" [toolTipArgs]="toolTipArgs" [showTooltip]="disableEachWayTooltip"></div>
                    <span class="each-way-label" [i18n]="'quickbet.eachWayLabel'" data-crlat="label.eachWay"></span>
                    <input
                        id="each-way-checkbox"
                        class="each-way-checkbox"
                        type="checkbox"
                        placeholder="0.00"
                        [disabled]="selection.disabled || serviceClosureService.userServiceClosureOrPlayBreak"
                        (change)="onStakeChange()"
                        [(ngModel)]="selection.isEachWay"
                        data-uat="eachWay" />
                    <label for="each-way-checkbox"></label>
                </div>
            </div>
        </section>
    </div>
    <div class="promos-boost">
        <!-- Boost button -->
        <div *ngIf="canBoostSelection" class="quickbet-boost-button">
            <lazy-component
                moduleUri="@oddsBoostModule/odds-boost.module#OddsBoostModule"
                entryComponent="OddsBoostButtonComponent"
                (click)="onBoostClick()"
                [inputs]="{
                    enabled: selection.isBoostActive,
                    reboost: selection.reboost,
                    disabled: placeBetPending.state,
                    isQuickBet: isQuickBet,
                }">
            </lazy-component>
        </div>
    </div>
</div>

<div class="reboost-info" *ngIf="canBoostSelection && selection.price.isPriceChanged && selection.isBoostActive">
    <svg class="alert-icon">
        <use xlink:href="#icn_info"></use>
    </svg>
    <span [i18n]="'quickbet.reboostPriceChanged'"></span>
</div>
